var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"aria-label":"Navigation Menu","aria-expanded":"true"}},[_c('div',{staticClass:"hamburger",class:{ open: _vm.open }},_vm._l((3),function(i){return _c('div',{key:i,staticClass:"line"})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }